import { useEffect, useState } from 'react'
import AssetsNav from '../../../elements/AssetsNav';
import { Button, Checkbox, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router';
import { DeletePopUp, NoRecordFound, PageLoader, Pagination, STableLoader, FilterComponent } from '../../../../shared_elements';
import { getLeasesBasicInfoApi } from '../apiService';
import { globalDeleteService, globalGetService } from '../../../../utils/globalApiServices';
import LeaseInfoList from '../comonents/LeaseInfoList';
import LeaseCRU from '../../../leases/components/LeaseCRU';
import { deleteLeaseApi } from '../../../leases/apiServices';
import { checkApiStatus } from '../../../../utils';
import { enqueueSnackbar } from 'notistack';
import LeaseChangeStatus from '../../../leases/components/LeaseChangeStatus';
import { ButtonLoader, ShowAttachments } from '../../../../shared_elements/components';
import { LeasesBasicDetails } from '../../../elements';
import AssetsMenueList from '../../../elements/AssetsMenuList';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import { useDispatch, useSelector } from 'react-redux';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import { PermissionWrapper } from '../../../../wrappers';
import { RoleBaseAccess } from '../../../../hoc';
import { getLesseeApi, getOwnerListApi, getOwnerLessorApi } from '../../../../shared_elements/actionCreators';
import { setLeaseBasicDetails } from '../../../../shared_elements/actions';
import { assetTypeMap } from '../../../leases/components/LeaseConstants';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 225px)';

const leaseStatusOptions = [
  { label: 'Draft', value: 'Draft' },
  { label: 'Active', value: 'Active' },
  { label: 'Closed', value: 'Closed' },
  { label: 'On-hold', value: 'On-hold' },
  { label: 'Terminated', value: 'Terminated' },
];

const leaseTypeOptions = [
  { label: 'Operating Lease', value: 3 },
  { label: 'Finance Lease', value: 4 },
  { label: 'Wet Lease', value: 2 },
  { label: 'Dry Lease', value: 1 },
];

const LeaseBasicInfoHd = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
  const draftItem=item?.filter(optionItem=>optionItem?.status==='Draft')
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Asset Leases`, page_type: page_type, })
  }
  const tableSorting = (key, name) => (
    <TableSortLabel
      sx={{ whiteSpace: "nowrap" }}
      active={sortInfo?.sort_by === key}
      direction={sortInfo?.sort_by === key ? sortInfo.sort : 'asc'}
      onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
    >
      <span style={{ color: sortInfo?.sort_by === key ? '#496ac5' : 'inherit' }}>
        {name}
      </span>
    </TableSortLabel>
  );

  return (
    <TableHead>
      <TableRow>
        <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "lease", operationType: ['D'] }}>
            <Checkbox
              color="primary"
              size="small"
              onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', draftItem)}
              checked={draftItem?.length === bulk?.ids?.length && draftItem?.length > 0}
            /></PermissionWrapper> Action(s) </TableCell>
        <TableCell>{tableSorting("status", "Status")}</TableCell>
        <TableCell>{tableSorting("reference_code", "Reference Code")}</TableCell>
        <TableCell>{tableSorting("assigned_code", "Assigned Code")}</TableCell>
        <TableCell>{tableSorting("lease_type", "Lease Type", true)}</TableCell>
        <TableCell>{tableSorting("lessee", "Lessee", true)}</TableCell>
        <TableCell sx={{ minWidth: '200px', textAlign: 'center' }}>Lease Duration / Term</TableCell>
        <TableCell colSpan={2} sx={{ minWidth: '200px', padding: '0px !important', border: '1px solid rgba(224, 224, 224, 1)', verticalAlign: 'middle' }}>
          <Table sx={{ width: '100%' }} >
            <TableHead className="assembly-tablerow-header">
              <TableRow >
                <TableCell colSpan={2} align='center' sx={{ padding: '0px !important', borderBottom: '1px solid rgba(224, 224, 224, 1) !important', verticalAlign: 'middle' }}>Due Date</TableCell>
              </TableRow>
              <TableRow >
                <TableCell align='center' sx={{  padding: '0px !important', border: '1px solid rgba(224, 224, 224, 1) !important', verticalAlign: 'middle' }}>Rent</TableCell>
                <TableCell align='center' sx={{  padding: '0px !important', border: '1px solid rgba(224, 224, 224, 1) !important', verticalAlign: 'middle' }}>Utilization</TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableCell>

      </TableRow>
    </TableHead>
  );
};


const AssetsDetails = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const params = useParams();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [addEditLeases, setAddEditLeases] = useState({ mode: '', modal: false, data: null });
  const [changeStatusLeases, setChangeStatusLeases] = useState({ mode: '', modal: false, data: null })
  const [deleteLeases, setDeleteLeases] = useState({ modal: false, data: null, })
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [leaseBasicInfo, setLeaseBasicInfo] = useState({ list: [], pagination: null });
  const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
  const [filter, setFilter] = useState({});
  const [attachments, setAttachments] = useState({ modal: false, data: null, mode:'' })
  const[isExport,seIsExport]=useState(false)
  const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' });
  const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
  const { fileUploadDetails, lessee, lessor, owner } = useSelector((state) => state.leases);
  const [uploadFileProgressData, setUploadFileProgressData] = useState({})
  const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
  const [slug, setSlug] = useState({})
  const AssetType = Number.isNaN(Number(params?.asset_type))
    ? Number(Object.keys(assetTypeMap).find((key) => assetTypeMap[key] === params?.asset_type))
    : Number(params?.asset_type);

  const leaseFilterMenu = {
    reference_code: { title: 'Ref Code', inputType: 'text' },
    assigned_code: { title: 'Assigned Code', inputType: 'text' },
    status: { title: 'Status', inputType: 'dropdown', options: leaseStatusOptions, valueKey: 'value', labelKey: 'label', multiple: false },
    lease_type: { title: 'Lease Type', inputType: 'dropdown', options: leaseTypeOptions, valueKey: 'value', labelKey: 'label', multiple: false },
    lessee_id: { title: 'Lessee', inputType: 'dropdown', options: lessee || [], valueKey: 'id', labelKey: 'name', multiple: false },
    lessor_name_id: { title: 'Lessor/Holdco', inputType: 'dropdown', options: owner || [], valueKey: 'id', labelKey: 'name', multiple: false },
    owner_id: { title: 'Owner/SPV', inputType: 'dropdown', options: owner || [], valueKey: 'id', labelKey: 'name', multiple: false },
    start_date: { title: 'Lease Start', inputType: 'date' },
    end_date: { title: 'Lease End', inputType: 'date' },
  };

  useEffect(() => {
    const uploadedFileData = getApiResponse("lease", slug);
    getLeaseBasicInfoList('skeletonLoader', {
      per_page: 50,
      asset_type: params?.asset_type,
      asset_slug: params?.asset_slug
    });
    trackActivity('Page Viewed', { page_title: 'Asset Leases' })
    setUploadFileProgressData({ uploadedFileData });
    if (!lessee?.length) dispatch(getLesseeApi());
    if (!lessor?.length) dispatch(getOwnerLessorApi());
    if (!owner?.length) dispatch(getOwnerListApi());
  }, []);

  useEffect(() => {
    getLeaseBasicInfoList('skeletonLoader', {
      per_page: 50,
      asset_type: params?.asset_type,
      asset_slug: params?.asset_slug
    });
  }, [params?.asset_slug]);

  const getLeaseBasicInfoList = (loaderType, query = {}) => {
    loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    globalGetService(getLeasesBasicInfoApi(params, query))
      .then(response => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        setLeaseBasicInfo(response?.data?.data);
      })
  }

  const onDeleteLease = () => {
    setLoading(true);
    globalDeleteService(deleteLeaseApi(),
      { ids: bulk?.type === 'bulk' || bulk?.type === 'single' ? bulk?.ids.map(item => item?.id) : [deleteLeases?.data?.id] }
    )
      .then(response => {
        if (checkApiStatus(response)) {
          trackActivity('Item Deleted', { page_title: `Delete Lease`, success_msg: response?.data?.message, item_ids: deleteLeases?.data || bulk?.ids, response: response?.data })
          setDeleteLeases({ modal: false, data: null });
          getLeaseBasicInfoList('fetch', { per_page: leaseBasicInfo?.pagination?.data || 50, basic_info: params?.basic_info, asset_type: params?.asset_type, asset_slug: params?.asset_slug });
          setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
        } else {
          setLoading(false);
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Deleted', { page_title: `Delete Lease`, error_msg: response?.data?.message, item_ids: deleteLeases?.data || bulk?.ids, response: response?.data })
        }
      })
  }

  const toggleBulkOps = (flag, type, item) => {
    if (type === 'bulk') {
      setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
    } else {
      setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
    }
  }

  const createSortHandler = (key) => {
    let sortQuery = { sort_by: key };
    if (sortInfo.sort_by === key) {
      sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
    } else {
      sortQuery = { ...sortQuery, sort: 'asc' }
    }
    setSortInfo(sortQuery)
    getLeaseBasicInfoList('', { ...filter, ...sortQuery, per_page: leaseBasicInfo?.pagination?.per_page || 50, asset_type: params?.asset_type, asset_slug: params?.asset_slug });
  }

  const onApplyFilter = (query) => {
    setFilter(query);
    getLeaseBasicInfoList('', { ...query, page: 1, per_page: leaseBasicInfo?.pagination?.per_page || 50, asset_type: params?.asset_type, asset_slug: params?.asset_slug });
  };

  const onDeteAttchments = (deltedslug) => {
    setAttachments({
      ...attachments, data: {
        ...attachments.data,
        attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
      }
    });
    if (addEditLeases?.modal) {
      setAddEditLeases({
        ...addEditLeases,
        data: {
          ...addEditLeases.data,
          attachments: addEditLeases.data.attachments.filter(item => item?.slug !== deltedslug)
        }
      })
    }
    getLeaseBasicInfoList('', { per_page: leaseBasicInfo?.pagination?.per_page || 50, asset_type: params?.asset_type, asset_slug: params?.asset_slug });
  }

  const handleExport=()=>{
    let query = { ...filter, export: true }
    if (sortInfo?.sort && sortInfo?.sort_by) {
      query = {
        ...query,
        sort: sortInfo?.sort,
        sort_by: sortInfo?.sort_by
      }
    }
        seIsExport(true);
        globalGetService(getLeasesBasicInfoApi( params,query)).then((response)=>{
            if (checkApiStatus(response)){
              enqueueSnackbar(
                     response?.data.message,
                     { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                   );
                    seIsExport(false);
            }
        })
  }
  const handleUpload = async (slug, mode) => {
    setSlug({ slug: slug })
    await fileUpload({
      attachments: fileUploadDetails.attachments,
      module_name: "lease",
      slug: slug,
      query: { section_type: 'headlines-attachments', record_action_type: mode },
      onStart: () => setLoading(true),
      onComplete: () => setLoading(false),
      onProgress: ({ progressRefs, attachments, response }) => {
        setUploadFileProgressData({ progressRefs, attachments, response });
      },
      onSuccess: (success_msg) => {
        enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
        getLeaseBasicInfoList('skeletonLoader', { per_page: leaseBasicInfo?.pagination?.per_page || 50, asset_type: params?.asset_type, asset_slug: params?.asset_slug });
      },
      onError: (err) => {
        enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
      }
    });
    setSlug({});
  }
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Asset Leases`, page_type: page_type, })
  }

  return (
    <>
    <LeasesBasicDetails />
      <Paper className="lease-details-section lease-nav-module-margin lease-module-paper" elevation={0}>
        <AssetsNav />
        <div className="lease-details-content">
          <Paper square className="responsive-paper">
            <Grid container spacing={1} className="responsive-grid" alignItems='end'>
              <Grid item size={{ md: 12, xs: 12 }} className="menu-container lease-list-link-mt">
                <AssetsMenueList pageLabel={`leases`} />
              </Grid>
              <Grid size='grow' sx={{ minWidth: 0 }}>
                {!skeletonLoader ? <div style={{marginTop:"0px", marginLeft:"-5px"}}><FilterComponent filter={filter} filterMenu={leaseFilterMenu} getResponseBack={onApplyFilter} /></div> : null}
              </Grid>
              <Grid item md={8} xs={12}>
                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ margin: 0,padding:0 }}>
                  <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"asset"} })}/></li>
                  {
                    bulk?.type && bulk?.ids?.length ?
                      <>
                        <li className='lease-mobile-button'>
                          <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                        </li>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "lease", operationType: ['D'] }}>
                        <li className='lease-mobile-button'>
                          <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.length})`}</Button>
                        </li>
                        </PermissionWrapper>
                      </> : null
                  }
                  {leaseBasicInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button> </li> : null}
                  <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "lease", operationType: ['C'] }}>
                    <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' variant="contained" color="primary" size='small' onClick={() => { setAddEditLeases({ modal: true, data: { asset: location?.state?.asset }, mode: 'add' }); handleItemClicked('Add Item Button') }} > Add Lease </Button> </li>
                  </PermissionWrapper>
                </ul>
              </Grid>
            </Grid>
          </Paper>
          <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: leaseBasicInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
            <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                {skeletonLoader ? <STableLoader count={4} rowCount={13} /> : (
                  <Table className="mui-table-format" stickyHeader>
                    <LeaseBasicInfoHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={leaseBasicInfo?.list} toggleBulkOps={toggleBulkOps} />
                    <TableBody>
                      {leaseBasicInfo?.list?.length > 0 && leaseBasicInfo?.list?.map((item, index) =>{
                        const updatedItem = { ...item, asset: { ...item.asset, asset_type: item?.asset_type }, lessor: { ...item?.lessor_detail } }
                        const uploadedFileData = getApiResponse("lease", item?.slug);
                        return(
                        <LeaseInfoList
                          slug={slug?.slug}
                          uploadedFileData={uploadedFileData}
                          uploadFileProgressData={uploadFileProgressData}
                          viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                          key={index}
                          item={item}
                          bulk={bulk}
                          viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                          statusChange={() => setChangeStatusLeases({ modal: true, data: { status: item?.status, reason: item?.reason, closure_date: item?.closure_date, id: item?.id, asset_slug: item?.asset_slug, asset_type: item?.asset_type, leaseSlug: item?.slug, lessor_id: item?.lessor, lease: item?.lease_id }, mode: "add" })}
                          onEditFn={() => setAddEditLeases({ modal: true, data: item, mode: 'edit' })}
                          onView={() => { dispatch(setLeaseBasicDetails(updatedItem)); navigate(`/lease/${item?.slug}/lease-details/headlines`); }}
                          onDeleteEolFn={() => setDeleteLeases({ modal: true, data: item, })}
                          toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                          onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                        />
                      )})}
                    </TableBody>
                  </Table>
                )}
            </div>
            <Paper square>
              {!skeletonLoader && !leaseBasicInfo?.list?.length && <NoRecordFound />}
              <Pagination
                pagination={leaseBasicInfo?.pagination}
                onPageChange={(event, newPage) => { const pageNum = newPage + 1; getLeaseBasicInfoList('pageLoader', { ...filter, page: pageNum, per_page: leaseBasicInfo.pagination.per_page, asset_type: params?.asset_type, asset_slug: params?.asset_slug }); }}
                onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getLeaseBasicInfoList('pageLoader', { ...filter, page: 1, per_page: perPage, asset_type: params?.asset_type, asset_slug: params?.asset_slug }); }}
              />
            </Paper>
          </Paper>
        </div>

        {
          addEditLeases.modal && (
            <LeaseCRU
              moduleName="leaseInfo"
              addEditLeases={addEditLeases}
              fileUpload={handleUpload}
              modeType={addEditLeases?.mode}
              getResponseBack={() => getLeaseBasicInfoList('fetch', { per_page: leaseBasicInfo.pagination.per_page, asset_type: params?.asset_type, asset_slug: params?.asset_slug })}
              onOpenAttachments={() => setAttachments({ modal: true, data: addEditLeases?.data, mode:'view' })}
              onToggleModal={() => setAddEditLeases({ modal: false, data: null, mode: '' })}
            />
          )
        }

        {deleteLeases.modal &&
          <DeletePopUp
            modal={deleteLeases.modal}
            title='Delete Lease'
            content={`Are you sure, you want to Delete?`}
            onToggleModal={() => setDeleteLeases({ modal: false, data: null })}
            onDeleteRecords={() => onDeleteLease()}
          />}
        {attachments.modal ?
          <ShowAttachments
            moduleName="Lease"
            url='delete-attachment'
            deleteQuery={{ section_type: 'headlines-attachments' }}
            attachmentsData={attachments}
            getResponseBack={onDeteAttchments}
            toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
            onViewDisabled={addEditLeases?.mode === 'view' || attachments?.mode==='view'}
            permissionKey='lease'
          /> : null
        }
        {bulk.modal ?
          <DeletePopUp
            modal={bulk.modal}
            title="Delete All Lease"
            onDeleteRecords={() => onDeleteLease()}
            content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
            onToggleModal={() => setBulk({ modal: false, ids: [] })}
          /> : null
        }
         {
          revisionHistory.modal &&  
          <RevisionHistory 
           asset_type={AssetType}
           asset_slug={params?.asset_slug}
           moduleName={"lease"}
           revisionHistory={revisionHistory}
           onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
          />
        }
        {
          changeStatusLeases?.modal &&
          <LeaseChangeStatus
            params={params}
            getList={() => getLeaseBasicInfoList('pageLoader', { per_page: leaseBasicInfo.pagination.per_page, asset_type: params?.asset_type, asset_slug: params?.asset_slug })}
            changeStatusLeases={changeStatusLeases}
            setChangeStatusLeases={() => setChangeStatusLeases({ ...changeStatusLeases, modal: false, mode: '', data: null })}
            onToggleModal={() => setChangeStatusLeases({ ...changeStatusLeases, modal: false, mode: '', data: null })} />
        }
          <FileUploadLayout
          uploadFileStatus={uploadFileStatus}
          open={uploadFileStatus?.modal}
          setUploadFileStatus={setUploadFileStatus}
          uploadFileProgressData={uploadFileProgressData}
          progressRefs={uploadFileProgressData?.progressRefs}
          attachments={uploadFileProgressData?.attachments}
          onDownloadComplete={()=> setSlug({})}
          />

        {isLoading ? <PageLoader /> : null}
      </Paper >
    </>
  )
}
export default RoleBaseAccess(AssetsDetails, { application: 'lease_revamp', feature: 'lease', operationType: ['R'] });
